module.exports = __webpack_public_path__ + "static/media/logo-back-white-junina.b09e96b2.png";